export default {"src":"/_next/static/media/personSparkle_64.0f0074b9.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};